export default {"src":"/_next/static/media/cplogo-white.38af89b6.svg","height":78,"width":378,"blurWidth":0,"blurHeight":0};